<template>
  <div class="mt-6">
    <!-- Rounded container -->
    <div
      @mouseover="onIconHover"
      @mouseleave="onIconLeave"
      class="relative flex justify-center items-center rounded-full transition duration-500 ease-in-out h-8 w-8 border-2 hover:bg-r-primary"
    >
      <!-- Icon -->
      <font-awesome-icon :icon="icon" :color="iconColor" size="sm" />

      <!-- Tooltip -->
      <div class="h-80 mb-20">
        <transition name="fade">
          <div v-if="isTooltipActive">
            <div>
              <span
                class="tooltiptext bg-gray-500"
                :style="tooltipStyle"
                v-html="tooltipHtml"
              />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // local state
  data() {
    return {
      // icon's color
      iconColor: "grey",

      // flag for tooltip active
      isTooltipActive: false
    }
  },

  // props
  props: {
    // icon's name prop
    icon: {
      type: String,
      default: "info"
    },

    // tooltip text with html
    tooltipHtml: {
      type: String,
      default: ""
    },

    // tooltip style
    tooltipStyle: {
      type: Object,
      default: () => {
        let baseStyle = {
          right: "-160%"
        }

        if (window.screen.width >= 1024) {
          baseStyle = {
            ...baseStyle,
            left: "100%"
          }
        }

        return baseStyle
      }
    }
  },

  // methods
  methods: {
    /**
     * on icon hover event fired
     */
    onIconHover() {
      // set color
      this.iconColor = "white"

      // set tooltip flag
      this.isTooltipActive = true

      // fired event from parent
      this.$emit("mouseover")
    },

    /**
     * on icon hover fired
     */
    onIconLeave() {
      // set color
      this.iconColor = "grey"

      // set tooltip flag
      this.isTooltipActive = false

      // fired event from parent
      this.$emit("mouseleave")
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/_main.scss";

.tooltiptext {
  width: 300px;
  font-size: 15px;
  color: #fff;
  padding: 10px;
  border-radius: 6px;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  // right: -160%;
  top: 0;
  z-index: 3;

  // @include media(">tablet") {
  //   left: 100%;
  // }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
